var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "appLayout",
      attrs: { page: "/dashboard", pageTitle: "Dashboard", tabs: true },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  staticClass: "pr-5 custom-tabs",
                  attrs: { "background-color": "transparent", height: "42px" },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                _vm._l(_vm.filterTabs, function (tab) {
                  return _c(
                    "v-tab",
                    {
                      key: tab.title,
                      staticClass: "no-link",
                      attrs: { href: tab.href },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass:
                            "no-link flex align-center justify-center min-h-full",
                          attrs: { href: tab.href, "preserve-state": "" },
                          on: {
                            click: function ($event) {
                              _vm.selectedPeople = []
                            },
                          },
                        },
                        [_vm._v(_vm._s(tab.title))]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-tabs-items",
        { attrs: { value: _vm.selectedTab, touchless: "" } },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "/dashboard/studio", transition: false } },
            [
              _c(
                "div",
                { staticClass: "pa-1 animate__animated animate__fadeIn" },
                [
                  _vm.can("View statistical reports")
                    ? _c("SoliStats", {
                        key: _vm.activeMemberships,
                        attrs: {
                          activeMemberships: _vm.activeMemberships,
                          firstVisits: _vm.assessments,
                          enrollments: _vm.enrollments,
                          withdrawals: _vm.withdrawals,
                          inquiries: _vm.inquiries,
                          leadConversion: _vm.leadConversion,
                          assessmentConversion: _vm.assessmentConversion,
                          dateHeaders: "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "soli-round" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "soli-grey pb-2" },
                                    [
                                      _vm._v(
                                        "\n                                    Studio Availability "
                                      ),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _vm.showAiSummary
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "text-shadow-blue",
                                              attrs: {
                                                icon: "",
                                                outlined: "",
                                                color: "accent",
                                                small: "",
                                                loading: _vm.aiSummaryLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$refs.availabilityFinder.aiSummary()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("auto_awesome")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("AvailabilityFinder", {
                                    ref: "availabilityFinder",
                                    attrs: {
                                      ageRanges: _vm.ageRanges,
                                      skillLevels: _vm.skillLevels,
                                      errors: _vm.errors,
                                    },
                                    on: {
                                      loaded: function ($event) {
                                        _vm.showAiSummary = true
                                      },
                                      aiSummaryLoading: function ($event) {
                                        _vm.aiSummaryLoading = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card",
                            { staticClass: "soli-round mt-6" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "soli-grey" },
                                    [
                                      _vm._v(
                                        "\n                                    Upcoming Events\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { staticClass: "pa-0" },
                                    _vm._l(
                                      _vm.eventRegisters,
                                      function (event, idx) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: event.id,
                                            staticClass: "soli-round",
                                            class: {
                                              "mb-3":
                                                idx <
                                                _vm.eventRegisters.length - 1,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.$inertia.get(
                                                  _vm.route(
                                                    "eventRegistration.show",
                                                    event.hashId
                                                  )
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass: "mr-8",
                                                attrs: { size: "64" },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: event.photo,
                                                    width: "64",
                                                    height: "64",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              {
                                                staticClass: "text-align-start",
                                              },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "soli-grey" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(event.name) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(event.date) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(event.time) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    "\n                                                Attending:\n                                                " +
                                                      _vm._s(event.attending) +
                                                      "/" +
                                                      _vm._s(event.capacity) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c("Clipboard", {
                                                  attrs: {
                                                    icon: "share",
                                                    color: "accent",
                                                    text: event.link,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "soli-round" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass:
                                        "soli-grey pb-0 overflow-visible",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    First Visits\n                                    "
                                      ),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { left: "", "offset-y": "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass: "z-50",
                                                          attrs: {
                                                            id: "menu-button",
                                                            small: "",
                                                            icon: "",
                                                            outlined: "",
                                                            color: "accent",
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "soli-blue-text text-shadow-blue",
                                                          attrs: { small: "" },
                                                        },
                                                        [_vm._v("tune")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "flex soli-round soli-grey",
                                                      attrs: {
                                                        ripple: false,
                                                        outlined: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.hideCanceled =
                                                            !_vm.hideCanceled
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        Hide Canceled\n                                                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color:
                                                              _vm.hideCanceled
                                                                ? "accent"
                                                                : null,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.hideCanceled
                                                                ? "toggle_on"
                                                                : "toggle_off"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "flex soli-round soli-grey",
                                                      attrs: {
                                                        ripple: false,
                                                        outlined: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.upcoming =
                                                            !_vm.upcoming
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        " +
                                                              _vm._s(
                                                                "View Last Week"
                                                              ) +
                                                              "\n                                                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: _vm.upcoming
                                                              ? null
                                                              : "accent",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.upcoming
                                                                ? "toggle_off"
                                                                : "toggle_on"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "px-4",
                                      attrs: { dense: "" },
                                      model: {
                                        value: _vm.assessmentTab,
                                        callback: function ($$v) {
                                          _vm.assessmentTab = $$v
                                        },
                                        expression: "assessmentTab",
                                      },
                                    },
                                    [
                                      _c("v-tab", [_vm._v("Review")]),
                                      _vm._v(" "),
                                      _c(
                                        "v-tab",
                                        [
                                          _vm.getRecentFeedback
                                            ? _c(
                                                "v-badge",
                                                {
                                                  attrs: {
                                                    content:
                                                      _vm.getRecentFeedback,
                                                  },
                                                },
                                                [_vm._v("Feedback")]
                                              )
                                            : _c("div", [_vm._v("Feedback")]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      attrs: { touchless: "" },
                                      model: {
                                        value: _vm.assessmentTab,
                                        callback: function ($$v) {
                                          _vm.assessmentTab = $$v
                                        },
                                        expression: "assessmentTab",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-container",
                                            [
                                              _c("DashboardFirstVisits", {
                                                attrs: {
                                                  events: _vm.upcoming
                                                    ? _vm.upcomingAssessments?.filter(
                                                        (e) =>
                                                          _vm.hideCanceled
                                                            ? !e.lesson
                                                                .cancelled
                                                            : true
                                                      )
                                                    : _vm.weekReview?.filter(
                                                        (e) =>
                                                          _vm.hideCanceled
                                                            ? !e.lesson
                                                                .cancelled
                                                            : true
                                                      ),
                                                  errors: _vm.errors,
                                                },
                                                on: {
                                                  success: function ($event) {
                                                    return _vm.showMessage()
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-container",
                                            [
                                              _c("AssessmentFeedback", {
                                                attrs: { events: _vm.feedback },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "/dashboard/reports", transition: false } },
            [
              _c(
                "div",
                { staticClass: "pa-1 animate__animated animate__fadeIn" },
                [_c("DashboardReports")],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "/dashboard/apps", transition: false } },
            [
              _c(
                "div",
                { staticClass: "pa-1 animate__animated animate__fadeIn" },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        _vm._l(_vm.apps, function (app) {
                          return _c(
                            "v-col",
                            {
                              key: app.src,
                              staticClass: "flex justify-center",
                              attrs: { cols: "3" },
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: app.url, target: "_blank" } },
                                [
                                  _c("div", { staticClass: "flex flex-col" }, [
                                    _c(
                                      "div",
                                      { staticClass: "flex justify-center" },
                                      [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c("v-img", {
                                              attrs: { src: app.src },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass: "py-3 flex justify-center",
                                        staticStyle: {
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(app.name))]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "/dashboard/me", transition: false } },
            [
              _c(
                "div",
                { staticClass: "pa-1 animate__animated animate__fadeIn" },
                [
                  _c("DashboardTeacher", {
                    attrs: {
                      myAgenda: _vm.myAgenda,
                      teachingHours: _vm.teachingHours,
                    },
                    on: {
                      success: function ($event) {
                        return _vm.showMessage()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "/dashboard/settings", transition: false } },
            [
              _c(
                "div",
                { staticClass: "pa-1 animate__animated animate__fadeIn" },
                [_c("DashboardSettings")],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }